module.exports = "<div class=\"its-404\">\n  404!\n</div>\n<div class=\"not-found\">\n  Looks like the page you're looking for doesn't exist! Try a different page.\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/404/404.component.html
// module id = ../../../../../src/app/pages/404/404.component.html
// module chunks = main